// App.tsx
import React, { useEffect, useState } from "react";
import {
  loadWordLibrary,
  getLibraryPathByDomain,
} from "./services/wordLibraryService";
import ErrorScreen from "./components/ui/ErrorScreen";
import LoadingScreen from "./components/ui/LoadingScreen";
import GameControls from "./components/ui/GameControl";
import Header from "./components/ui/Header";
import Timer from "./components/common/Timer";
import GameContent from "./components/ui/GameContent";

function App() {
  const [loadingState, setLoadingState] = useState<
    "loading" | "success" | "error"
  >("loading");

  useEffect(() => {
    const initializeLibrary = async () => {
      try {
        const libraryPath = getLibraryPathByDomain();
        await loadWordLibrary(libraryPath);
        setLoadingState("success");
      } catch (err) {
        console.error("词库加载失败:", err);
        setLoadingState("error");
      }
    };

    initializeLibrary();
  }, []);

  // 条件渲染：根据加载状态显示不同的内容
  if (loadingState === "loading") {
    return <LoadingScreen message="正在加载词库..." />;
  }

  if (loadingState === "error") {
    return (
      <ErrorScreen
        message="词库加载失败，请刷新页面重试"
        onRetry={() => window.location.reload()}
      />
    );
  }

  // 只有在加载成功时才渲染游戏内容
  return (
    <div className="app">
      <Header>
        <GameControls />
        <Timer />
      </Header>
      <GameContent />
    </div>
  );
}

export default App;
